import { cn } from "@/lib/utils";
import { theme } from "@/lib/theme";

export function ChitraImageGridSkeleton({ isDarkMode, isImageMode }: { isDarkMode: boolean; isImageMode?: boolean }) {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 pb-8 mb-16">
            {Array.from({ length: 8 }).map((_, index) => (
                <div
                    key={index}
                    className={cn(
                        "relative aspect-square rounded-xl overflow-hidden shadow-lg transition-all duration-300",
                        isImageMode
                            ? isDarkMode
                                ? "bg-white/5 border border-white/10 backdrop-blur-sm"
                                : "bg-white/40 border border-black/10 backdrop-blur-sm"
                            : ""
                    )}
                    style={{
                        background: isImageMode ? undefined : theme.shimmerGradient(isDarkMode),
                        backgroundSize: '200% 100%'
                    }}
                >
                    {!isImageMode && <div className="animate-shimmer absolute inset-0" />}
                    {isImageMode && (
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className={`w-8 h-8 rounded-full animate-pulse ${isDarkMode ? "bg-white/10" : "bg-black/10"}`}></div>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}
